import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { getGlobalClasses } from '../themes';

import AuthUserContainer from '../containers/AuthUser';
import Note from '../components/Note';
import RecentShifts from '../components/timeClock/recentShifts';
import PunchIn from '../components/timeClock/clockInAndOut';
import { clockInRequiredMessage } from '../components/timeClock/requireClockIn';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
	};
};

class ClockInAndOut extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	//- The driver was sent here from a report screen. After they clock in and
	//- close the success dialog, send them back to the report they wanted.
	handleClockInSuccessfulClose = () => {
		const { history, location } = this.props;
		const returnTo = _.get(location, 'state.returnTo');
		if (returnTo && history) {
			history.push(returnTo);
		}
	};

	render() {
		const { authUser, location } = this.props;

		let isDriver = authUser.role === 'driver';
		const clockInRequired = _.get(location, 'state.clockInRequired');
		return (
			<>
				{clockInRequired && <Note label={clockInRequiredMessage} />}
				<PunchIn
					showPrintDeliveryTickets={isDriver}
					userId={authUser.userId}
					onClockInSuccessfulClose={clockInRequired ? this.handleClockInSuccessfulClose : undefined}
				/>
				<RecentShifts />
			</>
		);
	}
}

ClockInAndOut.propTypes = {
	authUser: PropTypes.object,
	location: PropTypes.object,
	history: PropTypes.object,
};

export default _.flow([withStyles(styles), AuthUserContainer])(ClockInAndOut);
